export var ListVariant;
(function (ListVariant) {
    ListVariant["Default"] = "default";
    ListVariant["Square"] = "sqare";
})(ListVariant || (ListVariant = {}));
//# sourceMappingURL=list-variant.enum.js.map
